import React, {useState} from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import SearchBar from "../Search/SearchBar";
import {Link} from "react-router-dom";

const Header = ({
                    showFixed,
                    tours,
                    handleSearch,
                    resultsRef,
                    isTourDetailPage,
                    selectedLocations,
                    handleLocationChange
                }) => {
    return (
        <AppBar position={showFixed ? "fixed" : "static"} style={showFixed ? {
            height: '80px',
            zIndex: '200',
            textAlign: 'center',
            justifyContent: 'center',
            backgroundColor: '#539165',
            fontFamily: 'Poppins, BlinkMacSystemFont, -apple-system, "Segoe UI", "Roboto", "Helvetica", "Arial", sans-serif'
        } : {}}>
            <Toolbar>
                <Grid container style={{fontFamily: 'poppins-medium'}} alignItems="center" spacing={1}>
                    <Grid item xs={2}>
                        <Grid container alignItems="center" textAlign="center">
                            <div style={{display: 'flex', alignItems: 'center'}}>
                                <img
                                    src="https://res.cloudinary.com/drvydie5q/image/upload/v1720716566/Dynamic%20folders/xtkjneqkhreeiqpizhqh.png"
                                    alt=""
                                    style={{width: '70px', marginRight: '10px'}}
                                />
                                <Typography>
                                    THE DAYDREAMERS
                                </Typography>
                            </div>
                        </Grid>
                    </Grid>
                    <Grid item xs={7}>
                        {!isTourDetailPage && (
                            <SearchBar
                                tours={tours}
                                selectedLocations={selectedLocations}
                                handleLocationChange={handleLocationChange}
                                handleSearch={handleSearch}
                                resultsRef={resultsRef}
                            />
                        )}
                    </Grid>
                    <Grid item xs={1}>
                        <Link style={{color: 'white'}} to={'/tour'}>
                            <Button color="inherit">Home</Button>
                        </Link>
                    </Grid>
                    <Grid item xs={1}>
                        <Button color="inherit">Tours</Button>
                    </Grid>
                    <Grid item xs={1}>
                        <Button color="inherit">Contact</Button>
                    </Grid>
                </Grid>
            </Toolbar>
        </AppBar>
    );
};

export default Header;
